module.exports = __webpack_public_path__ + "img/dnp.5636b669.svg";